import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=8b54bc1c&scoped=true"
import script from "./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue?vue&type=script&lang=js"
import style0 from "./Gender.vue?vue&type=style&index=0&id=8b54bc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b54bc1c",
  null
  
)

export default component.exports